import { Component } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';
import { UserService } from '../../services/user.service';
import { UserSessionService } from '../../services/user-session.service';
import { DocumentService } from '../../services/document.service';
import { API_BASE_URL } from '../../services/api-base';
import { OrgStructureService } from '../../services/org-structure.service';
import { ControlDpService } from '../../services/controldp.service';
import { firstValueFrom } from 'rxjs';

type ModalType =
  | 'environment'
  | 'user'
  | 'environment-list'
  | 'document'
  | 'sector'
  | 'department'
  | 'location'
  | 'position'
  | 'sector-list'
  | 'department-list'
  | 'location-list'
  | null;
type UsersModal = 'users-list';
type ConfirmModal = { id: number; name: string } | null;
type UserConfirmModal = { id: number; name: string; action: 'delete' | 'deactivate' | 'reactivate' } | null;
type UserPermissionsSubTab = 'modules' | 'cadastros' | 'controlop' | 'controlhelp';
type EnvironmentModalTab = 'cadastro' | 'modulos' | 'logo-cor';



interface ModuleEntry {
  key: string;
  labelKey?: string;
  name?: string;
  can_view?: number;
  can_create?: number;
  can_manage?: number;
}


@Component({
  selector: 'app-cadastros',
  templateUrl: './cadastros.component.html',
  styleUrls: ['./cadastros.component.scss']
})



export class CadastrosComponent {


  private lockBodyScroll() {
  document.body.classList.add('cp-modal-open');
};

private unlockBodyScroll() {
  document.body.classList.remove('cp-modal-open');
};

  private readonly apiBase = `${API_BASE_URL}`;
  moduleCatalog: ModuleEntry[] = [
    { key: 'home', labelKey: 'CADASTROS.MODULES.HOME' },
    { key: 'intranet', labelKey: 'CADASTROS.MODULES.INTRANET' },
    { key: 'cadastros', labelKey: 'CADASTROS.MODULES.CADASTROS' },
    { key: 'controlsign', labelKey: 'CADASTROS.MODULES.CONTROLSIGN' },
    { key: 'controltask', labelKey: 'CADASTROS.MODULES.CONTROLTASK' },
    { key: 'controlproject', labelKey: 'CADASTROS.MODULES.CONTROLPROJECT' },
    { key: 'controlflow', labelKey: 'CADASTROS.MODULES.CONTROLFLOW' },
    { key: 'controlhelp', labelKey: 'CADASTROS.MODULES.CONTROLHELP' },
    { key: 'controlbordo', labelKey: 'CADASTROS.MODULES.CONTROLBORDO' },
    { key: 'controlchat', labelKey: 'CADASTROS.MODULES.CONTROLCHAT' },
    { key: 'controlcli', labelKey: 'CADASTROS.MODULES.CONTROLCLI' },
    { key: 'controldocs', labelKey: 'CADASTROS.MODULES.CONTROLDOCS' },
    { key: 'controlsafe', labelKey: 'CADASTROS.MODULES.CONTROLSAFE' },
    { key: 'controlmentor', labelKey: 'CADASTROS.MODULES.CONTROLMENTOR' },
    { key: 'controlquestion', labelKey: 'CADASTROS.MODULES.CONTROLQUESTION' },
    { key: 'controlai', labelKey: 'CADASTROS.MODULES.CONTROLAI' },
    { key: 'controlsocial', labelKey: 'CADASTROS.MODULES.CONTROLSOCIAL' },
    { key: 'controldp', labelKey: 'CADASTROS.MODULES.CONTROLDP' },
    { key: 'controlop', labelKey: 'CADASTROS.MODULES.CONTROLOP' },
    { key: 'controlinventory', name: 'ControlInventory' },
    { key: 'mystore', name: 'My Store' },
    { key: 'controldossie', name: 'ControlDossie' }
  ];
  cadastrosItems = [
    { key: 'environments', labelKey: 'CADASTROS.ITEMS.ENVIRONMENTS' },
    { key: 'users', labelKey: 'CADASTROS.ITEMS.USERS' },
    { key: 'documents', labelKey: 'CADASTROS.ITEMS.DOCUMENTS' },
    { key: 'sectors', labelKey: 'CADASTROS.ITEMS.SECTORS' },
    { key: 'departments', labelKey: 'CADASTROS.ITEMS.DEPARTMENTS' },
    { key: 'locations', labelKey: 'CADASTROS.ITEMS.LOCATIONS' },
    { key: 'positions', labelKey: 'CADASTROS.ITEMS.POSITIONS' }
  ];
  controlopTabOptions = [
    { key: 'dashboard', labelKey: 'CADASTROS.CONTROLOP.DASHBOARD' },
    { key: 'collaborators', labelKey: 'CADASTROS.CONTROLOP.COLLABORATORS' },
    { key: 'imports', labelKey: 'CADASTROS.CONTROLOP.IMPORTS' },
    { key: 'business', labelKey: 'CADASTROS.CONTROLOP.BUSINESS' },
    { key: 'forecast', labelKey: 'CADASTROS.CONTROLOP.FORECAST' },
    { key: 'closing', labelKey: 'CADASTROS.CONTROLOP.CLOSING' },
    { key: 'reports', labelKey: 'CADASTROS.CONTROLOP.REPORTS' },
    { key: 'extras', labelKey: 'CADASTROS.CONTROLOP.EXTRAS' }
  ];
  activeModal: ModalType = null;
  activeUsersModal: UsersModal | null = null;
  
  environmentForm = {
    tenant_name: '',
    document_num: '',
    responsible_name: '',
    responsible_email: '',
    primary_color: '#70c5c6',
    secondary_color: '#0a1f44',
    notes: '',
    allowed_ips: ''
  };
  environmentModules: string[] = [];
  logoFile: File | null = null;
  coverFile: File | null = null;
  logoPreview: string | null = null;
  coverPreview: string | null = null;
  dragging = { logo: false, cover: false };
  feedbackMessage = '';
  feedbackType: 'success' | 'error' | '' = '';
  savingEnvironment = false;
  environments: any[] = [];
  loadingEnvironments = false;
  deletingId: number | null = null;
  listError = '';
  listMessage = '';
  envFilter = '';
  envPage = 1;
  envPageSize = 10;
  readonly envPageSizeOptions = [10, 20, 30, 50];
  environmentTab: EnvironmentModalTab = 'cadastro';
  sectorFilter = '';
  departmentFilter = '';
  locationFilter = '';
  editingEnvironment: any = null;
  editingForm = {
    tenant_name: '',
    document_num: '',
    responsible_name: '',
    responsible_email: '',
    primary_color: '#70c5c6',
    secondary_color: '#0a1f44',
    notes: '',
    allowed_ips: ''
  };
  editLogoFile: File | null = null;
  editCoverFile: File | null = null;
  deleteModal: ConfirmModal = null;

  userForm: {
    name: string;
    email: string;
    employee_id: string;
    birth_date: string;
    role_id: string;
    sector_id: string | number;
    department_id: string | number;
    location_id: string | number;
  } = {
    name: '',
    email: '',
    employee_id: '',
    birth_date: '',
    role_id: '',
    sector_id: '',
    department_id: '',
    location_id: ''
  };
  availableModules: ModuleEntry[] = [];
  userModulePermissions: Record<string, { can_view: boolean; can_create: boolean; can_manage: boolean }> = {};
  controlopDepartments: number[] = [];
  controlopLocations: number[] = [];
  controlopTabs: string[] = [];
  controlhelpDepartments: number[] = [];
  controlhelpDepartmentOptions: Array<{ id: number; name: string; sector_id?: number | null; sector_name?: string }> = [];
  userCadastrosPermissions: Record<string, { can_view: boolean; can_create: boolean; can_manage: boolean }> = {};
  selfCadastrosPermissions: Record<string, { can_view: boolean; can_create: boolean; can_manage: boolean }> = {};
  hasCadastrosRestrictions = false;
  roles: any[] = [];
  loadingRoles = false;
  savingUser = false;
  userFeedback = '';
  userEmailFeedback = '';
  checkingUserEmail = false;
  usersList: any[] = [];
  loadingUsers = false;
  usersError = '';
  usersMessage = '';
  editingUser: any = null;
  userFilter = '';
  userStatusFilter: 'ALL' | 'ACTIVE' | 'PENDING' | 'INACTIVE' = 'ALL';
  userDepartmentFilter: number | 'ALL' = 'ALL';
  userEnvironmentFilter: number | 'ALL' = 'ALL';
  userFilteredList: any[] = [];
  userDepartmentOptionsList: Array<{ id: number; name: string }> = [];
  userEnvironmentOptions: Array<{ id: number; name: string }> = [];
  userPage = 1;
  userPageSize = 10;
  readonly userPageSizeOptions = [10, 20, 30, 50];
  userDeleteModal: UserConfirmModal = null;
  deletingUserId: number | null = null;
  userActiveToggle = false;
  userStep = 1;
  userEditTab = 1;
  userPermissionsSubTab: UserPermissionsSubTab = 'modules';
  canManageEnvironments = false;
  employeeLookupLoading = false;
  documentForm = {
    title: '',
    description: '',
    document_type: 'POLICY',
    require_read: true,
    require_accept: false,
    require_agreement: false,
    require_signature: false
  };
  documentTypeOptions = [
    { value: 'POLICY', labelKey: 'INTRANET_DASH.DOC_TYPE.POLICY' },
    { value: 'CONTRACT', labelKey: 'INTRANET_DASH.DOC_TYPE.CONTRACT' },
    { value: 'TERM', labelKey: 'INTRANET_DASH.DOC_TYPE.TERM' },
    { value: 'NOTICE', labelKey: 'INTRANET_DASH.DOC_TYPE.NOTICE' },
    { value: 'OTHER', labelKey: 'INTRANET_DASH.DOC_TYPE.OTHER' }
  ];
  documentFile: File | null = null;
  documentFileName = '';
  savingDocument = false;
  documents: any[] = [];
  loadingDocuments = false;
  documentsError = '';
  documentFilter = '';
  sectors: any[] = [];
  departments: any[] = [];
  locations: any[] = [];
  positions: any[] = [];
  positionFilter = '';
  positionForm = {
    name: '',
    base_salary: ''
  };
  sectorForm = {
    name: '',
    description: '',
    controlhelp_scope: 'BOTH'
  };
  readonly controlhelpScopeOptions = [
    { value: 'NONE', label: 'Não usa', icon: 'block', description: 'Não aparece no cadastro de chamados.' },
    { value: 'ORIGIN', label: 'Origem', icon: 'logout', description: 'Aparece somente como origem do chamado.' },
    { value: 'DESTINATION', label: 'Destino', icon: 'login', description: 'Aparece somente como departamento de atendimento.' },
    { value: 'BOTH', label: 'Ambos', icon: 'sync_alt', description: 'Aparece como origem e como destino.' }
  ];
  departmentForm = {
    sector_id: '',
    name: '',
    description: ''
  };
  locationForm = {
    sector_id: '',
    department_id: '',
    name: '',
    description: ''
  };

  constructor(
    private environmentService: EnvironmentService,
    private userService: UserService,
    private userSession: UserSessionService,
    private documentService: DocumentService,
    private orgStructureService: OrgStructureService,
    private controlDpService: ControlDpService
  ) {
    this.loadCurrentUserPermissions();
  }

  openModal(type: ModalType) {
    this.activeModal = type;
    this.clearFeedback();
    this.lockBodyScroll();

    if (type === 'environment') {
      this.environmentTab = 'cadastro';
    }

    if (type === 'environment-list') {
      this.fetchEnvironments();
    }

    if (type === 'user') {
      this.loadTenantAvailableModules();
      if (!this.roles.length) {
        this.loadRoles();
      }
      if (!this.editingUser) {
        this.resetUserForm();
      }
      this.userStep = 1;
      this.userPermissionsSubTab = 'modules';
      this.fetchSectors();
      this.fetchDepartments();
      this.fetchControlhelpDepartments();
      this.fetchLocations();
      this.resetUserModules();
      this.resetUserCadastrosPermissions();
    }

    if (type === 'document') {
      this.resetDocumentForm();
      this.fetchDocuments();
    }

    if (type === 'sector') {
      this.resetSectorForm();
      this.fetchSectors();
    }

    if (type === 'department') {
      this.resetDepartmentForm();
      this.fetchSectors();
      this.fetchDepartments();
    }

    if (type === 'location') {
      this.resetLocationForm();
      this.fetchSectors();
      this.fetchDepartments();
      this.fetchLocations();
    }

    if (type === 'position') {
      this.resetPositionForm();
      this.fetchPositions();
    }

    if (type === 'sector-list') {
      this.sectorFilter = '';
      this.fetchSectors();
    }

    if (type === 'department-list') {
      this.departmentFilter = '';
      this.fetchDepartments();
    }

    if (type === 'location-list') {
      this.locationFilter = '';
      this.fetchLocations();
    }
  }

  showComingSoon(label: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.setFeedback('error', `Cadastro de ${label} em desenvolvimento.`);
  }

  openUserModal() {
    this.editingUser = null;
    this.userFeedback = '';
    this.resetUserForm();
    this.userActiveToggle = false;
    this.userStep = 1;
    this.userPermissionsSubTab = 'modules';
    this.openModal('user');
  }

  closeModal() {
    this.activeModal = null;
    this.activeUsersModal = null;
    this.dragging = { logo: false, cover: false };
    this.editingEnvironment = null;
    this.editLogoFile = null;
    this.editCoverFile = null;
    this.deleteModal = null;
    this.userFeedback = '';
    this.editingUser = null;
    this.resetUserForm();
    this.userDeleteModal = null;
    this.deletingUserId = null;
    this.userActiveToggle = false;
    this.userStep = 1;
    this.resetDocumentForm();
    this.documentsError = '';
    this.documentFilter = '';
    this.resetSectorForm();
    this.resetDepartmentForm();
    this.resetLocationForm();
    this.sectorFilter = '';
    this.departmentFilter = '';
    this.locationFilter = '';
    this.positionFilter = '';
    this.controlhelpDepartmentOptions = [];
    this.environmentTab = 'cadastro';
    this.unlockBodyScroll();
  }

  setEnvironmentTab(tab: EnvironmentModalTab) {
    this.environmentTab = tab;
  }

  submitSector() {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id || !sessionUser?.id) {
      this.setFeedback('error', 'Não foi possível identificar o usuário atual.');
      return;
    }
    if (!this.sectorForm.name.trim()) {
      this.setFeedback('error', 'Informe o nome do setor.');
      return;
    }
    const payload = {
      tenant_id: sessionUser.tenant_id,
      created_by: sessionUser.id,
      name: this.sectorForm.name.trim(),
      description: this.sectorForm.description.trim(),
      controlhelp_scope: this.sectorForm.controlhelp_scope
    };
    this.orgStructureService.createSector(payload).subscribe({
      next: (created) => {
        this.sectors = [created, ...this.sectors];
        this.setFeedback('success', 'Setor cadastrado com sucesso.');
        this.closeModal();
      },
      error: (err) => {
        const message = err?.error?.error || 'Não foi possível cadastrar o setor.';
        this.setFeedback('error', message);
      }
    });
  }

  updateSectorControlhelpScope(sector: any, scope: string) {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id || !sector?.id) {
      return;
    }
    const previousScope = this.sectorControlhelpScope(sector);
    const previousEnabled = !!sector.controlhelp_enabled;
    sector.controlhelp_scope = scope;
    sector.controlhelp_enabled = scope !== 'NONE' ? 1 : 0;
    this.orgStructureService
      .updateSector(sector.id, { tenant_id: sessionUser.tenant_id, controlhelp_scope: scope })
      .subscribe({
        next: (updated) => {
          if (updated && typeof updated.controlhelp_enabled !== 'undefined') {
            sector.controlhelp_enabled = updated.controlhelp_enabled;
          }
          if (updated && typeof updated.controlhelp_scope !== 'undefined') {
            sector.controlhelp_scope = updated.controlhelp_scope;
          }
        },
        error: () => {
          sector.controlhelp_scope = previousScope;
          sector.controlhelp_enabled = previousEnabled ? 1 : 0;
          this.setFeedback('error', 'Não foi possível atualizar o ControlHelp para o setor.');
        }
      });
  }

  sectorControlhelpScope(sector: any) {
    const value = String(sector?.controlhelp_scope || '').toUpperCase();
    if (['NONE', 'ORIGIN', 'DESTINATION', 'BOTH'].includes(value)) {
      return value;
    }
    return sector?.controlhelp_enabled ? 'BOTH' : 'NONE';
  }

  controlhelpScopeLabel(scope: string) {
    return this.controlhelpScopeOptions.find((option) => option.value === scope)?.label || 'Não usa';
  }

  controlhelpScopeIcon(scope: string) {
    return this.controlhelpScopeOptions.find((option) => option.value === scope)?.icon || 'block';
  }

  submitDepartment() {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id || !sessionUser?.id) {
      this.setFeedback('error', 'Não foi possível identificar o usuário atual.');
      return;
    }
    if (!this.departmentForm.sector_id) {
      this.setFeedback('error', 'Selecione um setor.');
      return;
    }
    if (!this.departmentForm.name.trim()) {
      this.setFeedback('error', 'Informe o nome do departamento.');
      return;
    }
    const payload = {
      tenant_id: sessionUser.tenant_id,
      created_by: sessionUser.id,
      sector_id: Number(this.departmentForm.sector_id),
      name: this.departmentForm.name.trim(),
      description: this.departmentForm.description.trim()
    };
    this.orgStructureService.createDepartment(payload).subscribe({
      next: (created) => {
        this.departments = [created, ...this.departments];
        this.setFeedback('success', 'Departamento cadastrado com sucesso.');
        this.closeModal();
      },
      error: (err) => {
        const message = err?.error?.error || 'Não foi possível cadastrar o departamento.';
        this.setFeedback('error', message);
      }
    });
  }

  submitLocation() {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id || !sessionUser?.id) {
      this.setFeedback('error', 'Não foi possível identificar o usuário atual.');
      return;
    }
    if (!this.locationForm.sector_id) {
      this.setFeedback('error', 'Selecione um setor.');
      return;
    }
    if (!this.locationForm.department_id) {
      this.setFeedback('error', 'Selecione um departamento.');
      return;
    }
    if (!this.locationForm.name.trim()) {
      this.setFeedback('error', 'Informe o nome do local.');
      return;
    }
    const payload = {
      tenant_id: sessionUser.tenant_id,
      created_by: sessionUser.id,
      department_id: Number(this.locationForm.department_id),
      name: this.locationForm.name.trim(),
      description: this.locationForm.description.trim()
    };
    this.orgStructureService.createLocation(payload).subscribe({
      next: (created) => {
        this.locations = [created, ...this.locations];
        this.setFeedback('success', 'Local cadastrado com sucesso.');
        this.closeModal();
      },
      error: (err) => {
        const message = err?.error?.error || 'Não foi possível cadastrar o local.';
        this.setFeedback('error', message);
      }
    });
  }

  onLocationSectorChange() {
    this.locationForm.department_id = '';
  }

  getDepartmentsBySector(sectorId: string | number) {
    const id = Number(sectorId);
    if (!Number.isFinite(id)) {
      return [];
    }
    return this.departments.filter((d) => d.sector_id === id);
  }

  private fetchSectors() {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id) {
      return;
    }
    this.orgStructureService.getSectors(sessionUser.tenant_id).subscribe({
      next: (rows) => (this.sectors = rows || []),
      error: () => (this.sectors = [])
    });
  }

  private fetchDepartments() {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id) {
      return;
    }
    this.orgStructureService.getDepartments(sessionUser.tenant_id).subscribe({
      next: (rows) => (this.departments = rows || []),
      error: () => (this.departments = [])
    });
  }

  private fetchLocations() {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id) {
      return;
    }
    this.orgStructureService.getLocations(sessionUser.tenant_id).subscribe({
      next: (rows) => (this.locations = rows || []),
      error: () => (this.locations = [])
    });
  }

  private resetSectorForm() {
    this.sectorForm = { name: '', description: '', controlhelp_scope: 'BOTH' };
  }

  private resetDepartmentForm() {
    this.departmentForm = { sector_id: '', name: '', description: '' };
  }

  private resetLocationForm() {
    this.locationForm = { sector_id: '', department_id: '', name: '', description: '' };
  }

  private resetPositionForm() {
    this.positionForm = { name: '', base_salary: '' };
  }

  submitPosition() {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id || !sessionUser?.id) {
      this.setFeedback('error', 'Não foi possível identificar o usuário atual.');
      return;
    }
    if (!this.positionForm.name.trim()) {
      this.setFeedback('error', 'Informe o nome do cargo.');
      return;
    }
    const payload = {
      tenant_id: sessionUser.tenant_id,
      created_by: sessionUser.id,
      name: this.positionForm.name.trim(),
      base_salary: this.positionForm.base_salary ? Number(this.positionForm.base_salary) : null
    };
    this.controlDpService.createRole(payload).subscribe({
      next: (created) => {
        this.positions = [created, ...this.positions];
        this.setFeedback('success', 'Cargo cadastrado com sucesso.');
        this.closeModal();
      },
      error: (err) => {
        const message = err?.error?.error || 'Não foi possível cadastrar o cargo.';
        this.setFeedback('error', message);
      }
    });
  }

  private fetchPositions() {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id) {
      return;
    }
    this.controlDpService.listRoles(sessionUser.tenant_id).subscribe({
      next: (rows) => (this.positions = rows || []),
      error: () => (this.positions = [])
    });
  }

  get filteredPositions() {
    if (!this.positionFilter) {
      return this.positions;
    }
    const term = this.positionFilter.toLowerCase();
    return this.positions.filter((pos) => pos.name?.toLowerCase().includes(term));
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragEnter(type: 'logo' | 'cover') {
    this.dragging[type] = true;
  }

  onDragLeave(type: 'logo' | 'cover') {
    this.dragging[type] = false;
  }

  onFileDrop(event: DragEvent, type: 'logo' | 'cover') {
    event.preventDefault();
    this.dragging[type] = false;
    if (event.dataTransfer?.files?.length) {
      this.persistFile(event.dataTransfer.files[0], type);
    }
  }

  onFileSelect(event: Event, type: 'logo' | 'cover') {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.persistFile(input.files[0], type);
      input.value = '';
    }
  }

  private persistFile(file: File, type: 'logo' | 'cover') {
    if (!file.type.startsWith('image/')) {
      this.setFeedback('error', 'Envie apenas arquivos de imagem.');
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const isEditing = !!this.editingEnvironment;
      if (type === 'logo') {
        if (isEditing) {
          this.editLogoFile = file;
        } else {
          this.logoFile = file;
        }
        this.logoPreview = reader.result as string;
      } else {
        if (isEditing) {
          this.editCoverFile = file;
        } else {
          this.coverFile = file;
        }
        this.coverPreview = reader.result as string;
      }
    };
    reader.readAsDataURL(file);
  }

  submitEnvironment() {
    const isEditing = !!this.editingEnvironment;
    const form = isEditing ? this.editingForm : this.environmentForm;

    if (!form.tenant_name || !form.document_num || !form.responsible_name || !form.responsible_email) {
      this.setFeedback('error', 'Preencha os campos obrigatórios: Nome, Documento, Responsável e E-mail.');
      return;
    }
    if (!this.environmentModules.length) {
      this.setFeedback('error', 'Selecione ao menos um módulo para o ambiente.');
      return;
    }

    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => formData.append(key, value ?? ''));

    const logoFile = isEditing ? this.editLogoFile : this.logoFile;
    const coverFile = isEditing ? this.editCoverFile : this.coverFile;

    if (logoFile) formData.append('logo', logoFile);
    if (coverFile) formData.append('cover', coverFile);

    if (!isEditing) {
      const sessionUser = this.userSession.getUser();
      if (sessionUser?.id) {
        formData.append('created_by', sessionUser.id.toString());
      }
    }
    formData.append('modules', JSON.stringify(this.environmentModules));

    this.savingEnvironment = true;
    const request$ = isEditing
      ? this.environmentService.updateEnvironment(this.editingEnvironment.id, formData)
      : this.environmentService.createEnvironment(formData);

    request$.subscribe({
      next: () => {
        this.setFeedback('success', `Ambiente ${isEditing ? 'atualizado' : 'salvo'} com sucesso!`);
        this.resetEnvironmentForm();
        if (isEditing) {
          this.fetchEnvironments();
        }
        this.savingEnvironment = false;
        this.closeModal();
      },
      error: (err) => {
        const message = err?.error?.error || `Não foi possível ${isEditing ? 'atualizar' : 'salvar'} o ambiente.`;
        this.setFeedback('error', message);
        this.savingEnvironment = false;
      }
    });
  }

  openEnvironmentList(event: Event) {
    event.stopPropagation();
    this.envPage = 1;
    this.openModal('environment-list');
  }

  openSectorList(event: Event) {
    event.stopPropagation();
    this.openModal('sector-list');
  }

  openDepartmentList(event: Event) {
    event.stopPropagation();
    this.openModal('department-list');
  }

  openLocationList(event: Event) {
    event.stopPropagation();
    this.openModal('location-list');
  }

  openUsersList(event: Event) {
    event.stopPropagation();
    this.activeUsersModal = 'users-list';
    this.usersError = '';
    this.usersMessage = '';
    this.userFilter = '';
    this.userStatusFilter = 'ALL';
    this.userDepartmentFilter = 'ALL';
    this.userEnvironmentFilter = 'ALL';
    this.userPage = 1;
    this.fetchUsers();
  }

  openDocumentModal(event?: Event) {
    event?.stopPropagation();
    this.openModal('document');
  }

  onDocumentFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.documentFile = input.files[0];
      this.documentFileName = this.documentFile.name;
      input.value = '';
    }
  }

  submitDocument() {
    if (!this.documentForm.title || !this.documentFile) {
      this.setFeedback('error', 'Informe o título e selecione um arquivo PDF.');
      return;
    }
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id || !sessionUser?.id) {
      this.setFeedback('error', 'Não foi possível identificar o usuário atual.');
      return;
    }

    const formData = new FormData();
    formData.append('tenant_id', String(sessionUser.tenant_id));
    formData.append('title', this.documentForm.title);
    formData.append('description', this.documentForm.description || '');
    formData.append('document_type', this.documentForm.document_type);
    formData.append('require_read', this.documentForm.require_read ? '1' : '0');
    formData.append('require_accept', this.documentForm.require_accept ? '1' : '0');
    formData.append('require_agreement', this.documentForm.require_agreement ? '1' : '0');
    formData.append('require_signature', this.documentForm.require_signature ? '1' : '0');
    formData.append('created_by', String(sessionUser.id));
    formData.append('file', this.documentFile);

    this.savingDocument = true;
    this.documentService.createDocument(formData).subscribe({
      next: (doc) => {
        this.savingDocument = false;
        this.setFeedback('success', 'Documento cadastrado com sucesso.');
        this.documents.unshift(doc);
        this.resetDocumentForm();
      },
      error: (err) => {
        this.savingDocument = false;
        const message = err?.error?.error || 'Não foi possível salvar o documento.';
        this.setFeedback('error', message);
      }
    });
  }

  fetchEnvironments() {
    this.loadingEnvironments = true;
    this.listError = '';
    this.listMessage = '';
    this.environmentService.getEnvironments().subscribe({
      next: (rows) => {
        this.environments = rows;
        this.envPage = 1;
        this.loadingEnvironments = false;
      },
      error: (err) => {
        this.listError = err?.error?.error || 'Não foi possível carregar os ambientes.';
        this.loadingEnvironments = false;
      }
    });
  }

  loadRoles() {
    this.loadingRoles = true;
    this.userService.getRoles().subscribe({
      next: (roles) => {
        this.roles = roles;
        this.loadingRoles = false;
      },
      error: () => {
        this.loadingRoles = false;
      }
    });
  }

  fetchUsers(successMessage?: string) {
    this.loadingUsers = true;
    this.usersError = '';
    if (!successMessage) {
      this.usersMessage = '';
    }
    const sessionUser = this.userSession.getUser();
    const tenantId = Number(sessionUser?.tenant_id || 0);
    const usersRequest$ = this.canViewUsersFromAllTenants
      ? this.userService.getUsers()
      : tenantId
        ? this.userService.getUsersByTenant(tenantId, undefined, false, true)
        : this.userService.getUsers();
    usersRequest$.subscribe({
      next: (users) => {
        this.usersList = users;
        this.syncUserDepartmentOptions();
        this.syncUserEnvironmentOptions();
        this.applyUsersFilters();
        this.loadingUsers = false;
        if (successMessage) {
          this.usersMessage = successMessage;
        }
      },
      error: (err) => {
        this.usersList = [];
        this.userFilteredList = [];
        this.userDepartmentOptionsList = [];
        this.syncUserEnvironmentOptions();
        this.loadingUsers = false;
        this.usersError = err?.error?.error || 'Não foi possível carregar os usuários.';
      }
    });
  }

  get filteredUsers() {
    return this.userFilteredList;
  }

  get userDepartmentOptions() {
    return this.userDepartmentOptionsList;
  }

  get userCurrentPage() {
    const totalPages = this.userTotalPages;
    return Math.min(Math.max(1, this.userPage), totalPages);
  }

  get userTotalItems() {
    return this.filteredUsers.length;
  }

  get userTotalPages() {
    return Math.max(1, Math.ceil(this.userTotalItems / this.userPageSize));
  }

  get paginatedUsers() {
    const currentPage = this.userCurrentPage;
    const start = (currentPage - 1) * this.userPageSize;
    return this.filteredUsers.slice(start, start + this.userPageSize);
  }

  get userStartItem() {
    if (!this.userTotalItems) return 0;
    return (this.userCurrentPage - 1) * this.userPageSize + 1;
  }

  get userEndItem() {
    if (!this.userTotalItems) return 0;
    return Math.min(this.userCurrentPage * this.userPageSize, this.userTotalItems);
  }

  onUserFilterChange(value: string) {
    this.userFilter = value || '';
    this.userPage = 1;
    this.applyUsersFilters();
  }

  onUserStatusFilterChange(value: 'ALL' | 'ACTIVE' | 'PENDING' | 'INACTIVE') {
    this.userStatusFilter = value || 'ALL';
    this.userPage = 1;
    this.applyUsersFilters();
  }

  onUserDepartmentFilterChange(value: number | 'ALL') {
    this.userDepartmentFilter = value;
    this.userPage = 1;
    this.applyUsersFilters();
  }

  onUserEnvironmentFilterChange(value: number | 'ALL') {
    this.userEnvironmentFilter = value;
    this.userPage = 1;
    this.applyUsersFilters();
  }

  onUserPageSizeChange(value: string | number) {
    const parsed = Number(value);
    this.userPageSize = Number.isFinite(parsed) && parsed > 0 ? parsed : 10;
    this.userPage = 1;
  }

  goToUserPrevPage() {
    if (this.userCurrentPage > 1) {
      this.userPage = this.userCurrentPage - 1;
    }
  }

  goToUserNextPage() {
    if (this.userCurrentPage < this.userTotalPages) {
      this.userPage = this.userCurrentPage + 1;
    }
  }

  get canViewUsersFromAllTenants() {
    const sessionUser = this.userSession.getUser();
    const tenantId = Number(sessionUser?.tenant_id || 0);
    const roleName = String(sessionUser?.role_name ?? sessionUser?.role?.role_name ?? sessionUser?.role?.name ?? '').toLowerCase();
    const roleId = Number(sessionUser?.role_id || 0);
    const hasMasterFlag = Boolean(sessionUser?.['is_master'] ?? sessionUser?.['isMaster'] ?? sessionUser?.['master']);
    return tenantId === 1 && (hasMasterFlag || roleId === 1 || roleName.includes('master') || roleName.includes('admin'));
  }

  private syncUserEnvironmentOptions() {
    if (!this.canViewUsersFromAllTenants) {
      this.userEnvironmentOptions = [];
      this.userEnvironmentFilter = 'ALL';
      return;
    }
    const optionsMap = new Map<number, string>();
    (this.usersList || []).forEach((user) => {
      const id = Number(user?.tenant_id || 0);
      if (!id) {
        return;
      }
      if (!optionsMap.has(id)) {
        optionsMap.set(id, String(user?.tenant_name || user?.tenant || `Ambiente ${id}`));
      }
    });
    this.userEnvironmentOptions = Array.from(optionsMap.entries())
      .map(([id, name]) => ({ id, name }))
      .sort((a, b) => a.name.localeCompare(b.name));
    if (this.userEnvironmentFilter !== 'ALL') {
      const exists = this.userEnvironmentOptions.some((option) => option.id === Number(this.userEnvironmentFilter));
      if (!exists) {
        this.userEnvironmentFilter = 'ALL';
      }
    }
  }

  private syncUserDepartmentOptions() {
    const optionsMap = new Map<number, string>();
    (this.usersList || []).forEach((user) => {
      const id = Number(user?.department_id || 0);
      if (!id) {
        return;
      }
      if (!optionsMap.has(id)) {
        optionsMap.set(id, String(user?.department_name || `Departamento ${id}`));
      }
    });
    this.userDepartmentOptionsList = Array.from(optionsMap.entries())
      .map(([id, name]) => ({ id, name }))
      .sort((a, b) => a.name.localeCompare(b.name));
    if (this.userDepartmentFilter !== 'ALL') {
      const exists = this.userDepartmentOptionsList.some((option) => option.id === Number(this.userDepartmentFilter));
      if (!exists) {
        this.userDepartmentFilter = 'ALL';
      }
    }
  }

  private applyUsersFilters() {
    let list = this.usersList || [];
    if (this.userEnvironmentFilter !== 'ALL') {
      const tenantId = Number(this.userEnvironmentFilter);
      list = list.filter((user) => Number(user?.tenant_id) === tenantId);
    }
    if (this.userStatusFilter !== 'ALL') {
      list = list.filter((user) => this.getUserStatusKey(user) === this.userStatusFilter);
    }
    if (this.userDepartmentFilter !== 'ALL') {
      const departmentId = Number(this.userDepartmentFilter);
      list = list.filter((user) => Number(user?.department_id) === departmentId);
    }
    const term = String(this.userFilter || '').toLowerCase().trim();
    if (term) {
      list = list.filter(
        (user) =>
          String(user?.name || '').toLowerCase().includes(term) ||
          String(user?.email || '').toLowerCase().includes(term) ||
          String(user?.department_name || '').toLowerCase().includes(term)
      );
    }
    this.userFilteredList = list;
  }

  get filteredEnvironments() {
    if (!this.envFilter) {
      return this.environments;
    }

    const term = this.envFilter.toLowerCase();
    return this.environments.filter(env => env.tenant_name?.toLowerCase().includes(term));
  }

  get environmentCurrentPage() {
    const totalPages = this.environmentTotalPages;
    return Math.min(Math.max(1, this.envPage), totalPages);
  }

  get environmentTotalItems() {
    return this.filteredEnvironments.length;
  }

  get environmentTotalPages() {
    return Math.max(1, Math.ceil(this.environmentTotalItems / this.envPageSize));
  }

  get paginatedEnvironments() {
    const currentPage = this.environmentCurrentPage;
    const start = (currentPage - 1) * this.envPageSize;
    return this.filteredEnvironments.slice(start, start + this.envPageSize);
  }

  get environmentStartItem() {
    if (!this.environmentTotalItems) return 0;
    return (this.environmentCurrentPage - 1) * this.envPageSize + 1;
  }

  get environmentEndItem() {
    if (!this.environmentTotalItems) return 0;
    return Math.min(this.environmentCurrentPage * this.envPageSize, this.environmentTotalItems);
  }

  onEnvironmentFilterChange(value: string) {
    this.envFilter = value;
    this.envPage = 1;
  }

  onEnvironmentPageSizeChange(value: string | number) {
    const parsed = Number(value);
    this.envPageSize = Number.isFinite(parsed) && parsed > 0 ? parsed : 10;
    this.envPage = 1;
  }

  goToEnvironmentPrevPage() {
    if (this.environmentCurrentPage > 1) {
      this.envPage = this.environmentCurrentPage - 1;
    }
  }

  goToEnvironmentNextPage() {
    if (this.environmentCurrentPage < this.environmentTotalPages) {
      this.envPage = this.environmentCurrentPage + 1;
    }
  }

  get filteredSectors() {
    if (!this.sectorFilter) {
      return this.sectors;
    }
    const term = this.sectorFilter.toLowerCase();
    return this.sectors.filter((sector) => sector.name?.toLowerCase().includes(term));
  }

  get filteredDepartments() {
    if (!this.departmentFilter) {
      return this.departments;
    }
    const term = this.departmentFilter.toLowerCase();
    return this.departments.filter((dept) => {
      const name = (dept.name || '').toLowerCase();
      const sectorName = (dept.sector_name || '').toLowerCase();
      return name.includes(term) || sectorName.includes(term);
    });
  }

  get filteredLocations() {
    if (!this.locationFilter) {
      return this.locations;
    }
    const term = this.locationFilter.toLowerCase();
    return this.locations.filter((loc) => {
      const name = (loc.name || '').toLowerCase();
      const deptName = (loc.department_name || '').toLowerCase();
      const sectorName = (loc.sector_name || '').toLowerCase();
      return name.includes(term) || deptName.includes(term) || sectorName.includes(term);
    });
  }

  get filteredDocuments() {
    if (!this.documentFilter) {
      return this.documents;
    }
    const term = this.documentFilter.toLowerCase();
    return this.documents.filter(doc => doc.title?.toLowerCase().includes(term));
  }

  async submitUserForm() {
    if (!this.userForm.name || !this.userForm.email || !this.userForm.role_id) {
      this.userFeedback = 'Preencha os campos obrigatórios.';
      return;
    }
    if (this.userStep === 1 && !this.editingUser) {
      const emailOk = await this.ensureUserEmailIsAvailable();
      if (!emailOk) {
        return;
      }
      this.userFeedback = '';
      this.userStep = 2;
      return;
    }

    if (this.userStep === 2 && !this.editingUser) {
      this.userFeedback = '';
      this.userStep = 3;
      return;
    }

    const modulesPayload = this.buildUserModulesPayload();
    if (!modulesPayload.length) {
      this.userFeedback = 'Selecione ao menos um módulo para o usuário.';
      return;
    }
    const cadastrosModule = modulesPayload.find((module: any) => module.key === 'cadastros');
    const controlopModule = modulesPayload.find((module: any) => module.key === 'controlop');
    const controlhelpModule = modulesPayload.find((module: any) => module.key === 'controlhelp');
    let cadastrosPayload: any[] = [];
    if (cadastrosModule) {
      cadastrosPayload = this.buildCadastrosPayload();
      if (!cadastrosPayload.length) {
        this.userFeedback = 'Selecione permissões para o módulo Cadastros.';
        return;
      }
    }
    if (controlopModule && !this.controlopDepartments.length) {
      this.userFeedback = 'Selecione ao menos um departamento para o ControlOP.';
      return;
    }
    if (controlopModule && !this.controlopTabs.length) {
      this.userFeedback = 'Selecione ao menos uma aba de visualização para o ControlOP.';
      return;
    }
    if (controlhelpModule && !this.controlhelpDepartments.length) {
      this.userFeedback = 'Selecione ao menos um departamento para o ControlHelp.';
      return;
    }

    let tenantId: number | null = null;
    if (!this.editingUser) {
      const sessionUser = this.userSession.getUser();
      tenantId = sessionUser?.tenant_id ?? null;
      if (!tenantId) {
        this.userFeedback = 'Não foi possível identificar o tenant.';
        return;
      }
      const emailOk = await this.ensureUserEmailIsAvailable();
      if (!emailOk) {
        return;
      }
    }

    const payload: any = {
      ...this.userForm,
      role_id: Number(this.userForm.role_id),
      sector_id: this.userForm.sector_id ? Number(this.userForm.sector_id) : null,
      department_id: this.userForm.department_id ? Number(this.userForm.department_id) : null,
      location_id: this.userForm.location_id ? Number(this.userForm.location_id) : null
    };
    payload.modules = modulesPayload;
    if (cadastrosModule) {
      payload.cadastros_permissions = cadastrosPayload;
    }
    if (controlopModule) {
      payload.controlop_departments = this.controlopDepartments;
      payload.controlop_locations = this.controlopLocations;
      payload.controlop_tabs = this.controlopTabs;
    }
    if (controlhelpModule) {
      payload.controlhelp_departments = this.controlhelpDepartments;
    }

    if (!this.editingUser) {
      payload.tenant_id = tenantId;
    } else if (!this.isPendingUser(this.editingUser)) {
      payload.active = this.userActiveToggle ? 1 : 0;
    }

    this.savingUser = true;
    this.userFeedback = '';

    if (this.editingUser) {
      this.userService.updateUser(this.editingUser.id, payload).subscribe({
        next: () => {
          this.savingUser = false;
          this.userFeedback = 'Usuário atualizado com sucesso.';
          this.editingUser = null;
          this.closeModal();
          this.activeUsersModal = 'users-list';
          this.fetchUsers('Usuário atualizado com sucesso.');
        },
        error: (err) => {
          this.savingUser = false;
          this.userFeedback = err?.error?.error || 'Erro ao atualizar usuário.';
        }
      });
    } else {
      this.userService.createUser(payload).subscribe({
        next: (response) => {
          this.savingUser = false;
          this.userFeedback = response?.warning || response?.message || 'Usuário cadastrado! Enviamos um e-mail de ativação.';
          this.resetUserForm();
          this.userStep = 1;
        },
        error: (err) => {
          this.savingUser = false;
          if (err?.status === 409) {
            this.userFeedback = err?.error?.error || 'Esse e-mail já está cadastrado. Use outro endereço ou reative o usuário existente.';
            this.userEmailFeedback = this.userFeedback;
            return;
          }
          this.userFeedback = err?.error?.error || err?.message || 'Erro ao cadastrar usuário.';
        }
      });
    }
  }

  openDeleteConfirm(env: any) {
    this.deleteModal = { id: env.id, name: env.tenant_name };
  }

  cancelDelete() {
    this.deleteModal = null;
    this.deletingId = null;
  }

  confirmDelete() {
    if (!this.deleteModal) {
      return;
    }

    const envId = this.deleteModal.id;
    this.deletingId = envId;

    this.environmentService.deleteEnvironment(envId).subscribe({
      next: () => {
        this.environments = this.environments.filter(env => env.id !== envId);
        this.cancelDelete();
      },
      error: (err) => {
        alert(err?.error?.error || 'Erro ao remover ambiente.');
        this.cancelDelete();
      }
    });
  }

  resendMasterEmail(env: any) {
    this.listError = '';
    this.listMessage = '';
    this.environmentService.resendMasterEmail(env.id).subscribe({
      next: () => {
        this.listMessage = `E-mail de ativação reenviado para ${env.responsible_email}.`;
      },
      error: (err) => {
        this.listError = err?.error?.error || 'Não foi possível reenviar o e-mail.';
      }
    });
  }

  resendUserEmail(user: any) {
    if (!this.isPendingUser(user)) {
      this.usersError = 'O reenvio de acesso está disponível apenas para usuários pendentes.';
      this.usersMessage = '';
      return;
    }
    this.usersError = '';
    this.usersMessage = '';
    this.userService.resendActivationEmail(user.id).subscribe({
      next: () => {
        this.usersMessage = `E-mail reenviado para ${user.email}.`;
      },
      error: (err) => {
        this.usersError = err?.error?.error || 'Erro ao reenviar e-mail.';
      }
    });
  }

  resetUserPassword(user: any) {
    this.usersError = '';
    this.usersMessage = '';
    this.userService.resetPassword(user.id).subscribe({
      next: () => {
        user.active = 0;
        this.usersMessage = `Reset de senha enviado para ${user.email}.`;
      },
      error: (err) => {
        this.usersError = err?.error?.error || 'Erro ao resetar senha.';
      }
    });
  }

  toggleUserIpAccess(user: any) {
    this.usersError = '';
    this.usersMessage = '';
    const nextValue = !user.ip_access_exempt;
    this.userService.updateUserIpAccess(user.id, nextValue).subscribe({
      next: () => {
        user.ip_access_exempt = nextValue ? 1 : 0;
        this.usersMessage = nextValue
          ? `Acesso sem IP liberado para ${user.email}.`
          : `Acesso sem IP bloqueado para ${user.email}.`;
      },
      error: (err) => {
        this.usersError = err?.error?.error || 'Erro ao atualizar acesso por IP.';
      }
    });
  }

  openUserDelete(user: any) {
    this.userDeleteModal = {
      id: user.id,
      name: user.name,
      action: this.isPendingUser(user)
        ? 'delete'
        : this.getUserStatusKey(user) === 'INACTIVE'
          ? 'reactivate'
          : 'deactivate'
    };
    this.deletingUserId = null;
  }

  cancelUserDelete() {
    this.userDeleteModal = null;
    this.deletingUserId = null;
  }

  confirmUserDelete() {
    if (!this.userDeleteModal) {
      return;
    }

    const { id, action } = this.userDeleteModal;
    const sessionUser = this.userSession.getUser();
    this.deletingUserId = id;
    const request$ = action === 'delete'
      ? this.userService.deleteUser(id, Number(sessionUser?.id || 0) || undefined)
      : action === 'reactivate'
        ? this.userService.reactivateUser(id)
        : this.userService.deactivateUser(id, Number(sessionUser?.id || 0) || undefined);

    request$.subscribe({
      next: (response) => {
        this.usersError = '';
        this.cancelUserDelete();
        const fallbackMessage = action === 'delete'
          ? 'Usuário excluído.'
          : action === 'reactivate'
            ? 'Usuário reativado.'
            : 'Usuário inativado.';
        this.fetchUsers(response?.message || fallbackMessage);
      },
      error: (err) => {
        this.deletingUserId = null;
        const fallbackError = action === 'delete'
          ? 'Erro ao remover usuário.'
          : action === 'reactivate'
            ? 'Erro ao reativar usuário.'
            : 'Erro ao inativar usuário.';
        this.usersError = err?.error?.error || fallbackError;
      }
    });
  }

  editEnvironment(env: any) {
    this.editingEnvironment = env;
    this.editingForm = {
      tenant_name: env.tenant_name,
      document_num: env.document_num,
      responsible_name: env.responsible_name,
      responsible_email: env.responsible_email || '',
      primary_color: env.primary_color || '#70c5c6',
      secondary_color: env.secondary_color || '#0a1f44',
      notes: env.notes || '',
      allowed_ips: env.allowed_ips || ''
    };
    this.editLogoFile = null;
    this.editCoverFile = null;
    this.logoPreview = env.logo_url ? this.formatDocumentUrl(env.logo_url) : null;
    this.coverPreview = env.cover_url ? this.formatDocumentUrl(env.cover_url) : null;
    this.environmentModules = Array.isArray(env.modules) ? [...env.modules] : [];
    this.openModal('environment');
    if (!this.environmentModules.length && env.id) {
      this.environmentService.getTenantModules(env.id).subscribe({
        next: (rows) => {
          this.environmentModules = rows.map((row) => row.module_key);
        },
        error: () => {}
      });
    }
  }

  private resetEnvironmentForm() {
    this.environmentForm = {
      tenant_name: '',
      document_num: '',
      responsible_name: '',
      responsible_email: '',
      primary_color: '#70c5c6',
      secondary_color: '#0a1f44',
      notes: '',
      allowed_ips: ''
    };
    this.environmentModules = [];
    this.logoFile = null;
    this.coverFile = null;
    this.logoPreview = null;
    this.coverPreview = null;
    this.editLogoFile = null;
    this.editCoverFile = null;
  }

  private setFeedback(type: 'success' | 'error', message: string) {
    this.feedbackType = type;
    this.feedbackMessage = message;
  }

  private clearFeedback() {
    this.feedbackType = '';
    this.feedbackMessage = '';
  }

  private resetUserForm() {
    this.userForm = {
      name: '',
      email: '',
      employee_id: '',
      birth_date: '',
      role_id: '',
      sector_id: '',
      department_id: '',
      location_id: ''
    };
    this.userActiveToggle = false;
    this.userEmailFeedback = '';
    this.checkingUserEmail = false;
    this.controlopDepartments = [];
    this.controlopLocations = [];
    this.controlopTabs = [];
    this.controlhelpDepartments = [];
    this.userPermissionsSubTab = 'modules';
  }

  goToUserStep(step: number) {
    if (step < 1 || step > 3) {
      return;
    }
    this.userStep = step;
    if (step === 3) {
      this.loadTenantAvailableModules();
    }
    if (step !== 3) {
      this.userPermissionsSubTab = 'modules';
    }
    this.userFeedback = '';
  }

  setUserEditTab(tab: number) {
    if (tab < 1 || tab > 3) {
      return;
    }
    this.userEditTab = tab;
    if (tab === 3) {
      this.loadTenantAvailableModules();
    }
    if (tab !== 3) {
      this.userPermissionsSubTab = 'modules';
    }
    this.userFeedback = '';
  }

  setUserPermissionsSubTab(tab: UserPermissionsSubTab) {
    this.userPermissionsSubTab = tab;
    this.ensureUserPermissionsSubTab();
  }

  get isAllEnvironmentModulesSelected() {
    return !!this.moduleCatalog.length && this.environmentModules.length === this.moduleCatalog.length;
  }

  toggleAllEnvironmentModules(checked: boolean) {
    if (checked) {
      this.environmentModules = this.moduleCatalog.map((module) => module.key);
      return;
    }
    this.environmentModules = [];
  }

  toggleEnvironmentModule(moduleKey: string, checked: boolean) {
    if (checked) {
      if (!this.environmentModules.includes(moduleKey)) {
        this.environmentModules = [...this.environmentModules, moduleKey];
      }
    } else {
      this.environmentModules = this.environmentModules.filter((key) => key !== moduleKey);
    }
  }

  onUserSectorChange(sectorId?: string | number) {
    if (typeof sectorId !== 'undefined') {
      this.userForm.sector_id = this.normalizeSelectValue(sectorId);
    }
    this.userForm.department_id = '';
    this.userForm.location_id = '';
  }

  onUserDepartmentChange(departmentId?: string | number) {
    if (typeof departmentId !== 'undefined') {
      this.userForm.department_id = this.normalizeSelectValue(departmentId);
    }
    const dept = this.departments.find((d) => String(d.id) === String(this.userForm.department_id));
    if (dept?.sector_id) {
      this.userForm.sector_id = this.normalizeSelectValue(dept.sector_id);
    }
    this.userForm.location_id = '';
  }

  onUserLocationChange(locationId?: string | number) {
    if (typeof locationId !== 'undefined') {
      this.userForm.location_id = this.normalizeSelectValue(locationId);
    }
    const loc = this.locations.find((l) => String(l.id) === String(this.userForm.location_id));
    if (loc?.department_id) {
      this.userForm.department_id = this.normalizeSelectValue(loc.department_id);
    }
    if (loc?.sector_id) {
      this.userForm.sector_id = this.normalizeSelectValue(loc.sector_id);
    }
  }

  async validateUserEmailAvailability() {
    await this.ensureUserEmailIsAvailable();
  }

  lookupEmployeeByCode() {
    if (this.editingUser) {
      return;
    }
    const employeeCode = (this.userForm.employee_id || '').trim();
    if (!employeeCode) {
      return;
    }
    const sessionUser = this.userSession.getUser();
    const tenantId = sessionUser?.tenant_id ?? null;
    if (!tenantId) {
      this.userFeedback = 'Não foi possível identificar o tenant.';
      return;
    }

    this.employeeLookupLoading = true;
    this.userFeedback = '';

    this.controlDpService.findEmployeeByCode(tenantId, employeeCode).subscribe({
      next: (employee) => {
        this.employeeLookupLoading = false;
        this.userForm.name = employee?.full_name || this.userForm.name;
        this.userForm.email = employee?.corporate_email || employee?.personal_email || this.userForm.email;
        this.userForm.birth_date = this.normalizeDateToInput(employee?.birth_date);
      },
      error: (err) => {
        this.employeeLookupLoading = false;
        if (err?.status === 404) {
          this.userFeedback = 'Matrícula não encontrada nos colaboradores do ControlDP.';
          this.userForm.name = '';
          this.userForm.email = '';
          this.userForm.birth_date = '';
          return;
        }
        this.userFeedback = err?.error?.error || 'Erro ao buscar matrícula no ControlDP.';
      }
    });
  }

  private normalizeDateToInput(value?: string | null): string {
    if (!value) {
      return '';
    }
    return value.split('T')[0];
  }

  private normalizeSelectValue(value: any): string | number {
    const num = Number(value);
    return Number.isFinite(num) && num > 0 ? num : '';
  }

  private normalizeEmail(value: string): string {
    return String(value || '').trim().toLowerCase();
  }

  private async ensureUserEmailIsAvailable(): Promise<boolean> {
    if (this.editingUser) {
      return true;
    }

    const email = this.normalizeEmail(this.userForm.email);
    if (!email) {
      this.userEmailFeedback = '';
      return false;
    }

    this.checkingUserEmail = true;
    this.userEmailFeedback = '';

    try {
      const result = await firstValueFrom(this.userService.checkEmailAvailability(email));
      if (result?.exists) {
        this.userEmailFeedback = 'Esse e-mail já está cadastrado. Use outro endereço ou reative o usuário existente.';
        this.userFeedback = this.userEmailFeedback;
        return false;
      }
      return true;
    } catch (err: any) {
      this.userEmailFeedback = err?.error?.error || 'Não foi possível verificar o e-mail.';
      this.userFeedback = this.userEmailFeedback;
      return false;
    } finally {
      this.checkingUserEmail = false;
    }
  }

  getLocationsByDepartment(departmentId: string | number) {
    const id = Number(departmentId);
    if (!Number.isFinite(id)) {
      return [];
    }
    return this.locations.filter((l) => l.department_id === id);
  }

  get controlopAvailableLocations() {
    if (!this.controlopDepartments.length) {
      return [];
    }
    const allowed = new Set(this.controlopDepartments.map((id) => Number(id)));
    return this.locations.filter((loc) => allowed.has(Number(loc.department_id)));
  }

  editUser(user: any) {
    this.activeUsersModal = null;
    this.editingUser = user;
    const toSelectValue = (value: any) => {
      const num = Number(value);
      return Number.isFinite(num) && num > 0 ? num : '';
    };
    this.userForm = {
      name: user.name || '',
      email: user.email || '',
      employee_id: user.employee_id || '',
      birth_date: this.normalizeDateToInput(user.birth_date),
      role_id: user.role_id ? String(user.role_id) : '',
      sector_id: toSelectValue(user.sector_id),
      department_id: toSelectValue(user.department_id),
      location_id: toSelectValue(user.location_id)
    };
    this.userActiveToggle = !!user.active;
    this.userFeedback = '';
    this.userStep = 1;
    this.userEditTab = 1;
    this.userPermissionsSubTab = 'modules';
    this.openModal('user');
    this.loadUserModules(user.id);
    this.loadUserCadastrosPermissions(user.id);
    this.loadUserControlopAssignments(user.id);
    this.loadUserControlhelpAssignments(user.id);
  }

  getUserStatus(user: any): string {
    const statusKey = this.getUserStatusKey(user);
    if (statusKey === 'ACTIVE') {
      return 'Ativo';
    }
    if (statusKey === 'INACTIVE') {
      return 'Inativo';
    }
    return 'Pendente';
  }

  getUserStatusClasses(user: any) {
    const statusKey = this.getUserStatusKey(user);
    return {
      active: statusKey === 'ACTIVE',
      inactive: statusKey === 'INACTIVE',
      pending: statusKey === 'PENDING'
    };
  }

  private getUserStatusKey(user: any): 'ACTIVE' | 'PENDING' | 'INACTIVE' {
    if (user?.deleted_at) {
      return 'INACTIVE';
    }
    if (user?.active) {
      return 'ACTIVE';
    }
    if (user?.first_password_change_at) {
      return 'INACTIVE';
    }
    return 'PENDING';
  }

  isPendingUser(user: any): boolean {
    return !!user && !user.active && !user.first_password_change_at;
  }

  isUserDeletable(user: any): boolean {
    return this.isPendingUser(user);
  }

  isUserDeactivatable(user: any): boolean {
    return !!user && !this.isPendingUser(user);
  }

  formatDocumentUrl(path: string) {
    if (!path) {
      return '#';
    }
    if (path.startsWith('http')) {
      return path;
    }
    return `${this.apiBase}${path}`;
  }

  private fetchDocuments() {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id) {
      this.documentsError = 'Não foi possível identificar o tenant.';
      return;
    }
    this.loadingDocuments = true;
    this.documentService.listDocuments(sessionUser.tenant_id).subscribe({
      next: (docs) => {
        this.documents = docs;
        this.loadingDocuments = false;
      },
      error: (err) => {
        this.loadingDocuments = false;
        this.documentsError = err?.error?.error || 'Não foi possível carregar os documentos.';
      }
    });
  }

  private resetDocumentForm() {
    this.documentForm = {
      title: '',
      description: '',
      document_type: 'POLICY',
      require_read: true,
      require_accept: false,
      require_agreement: false,
      require_signature: false
    };
    this.documentFile = null;
    this.documentFileName = '';
  }

  private loadCurrentUserPermissions() {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser) {
      return;
    }
    const roleId = Number(sessionUser.role_id);
    this.canManageEnvironments = roleId === 1;
    this.availableModules = [...this.moduleCatalog];
    this.loadTenantAvailableModules();
    this.resetUserModules();
    this.loadSelfCadastrosPermissions(sessionUser);
  }

  private loadTenantAvailableModules() {
    const sessionUser = this.userSession.getUser();
    const tenantId = Number(sessionUser?.tenant_id);
    if (!tenantId) {
      this.availableModules = [...this.moduleCatalog];
      return;
    }

    const catalogMap = new Map(this.moduleCatalog.map((item) => [item.key, item]));
    this.environmentService.getTenantModules(tenantId).subscribe({
      next: (rows) => {
        const normalized = Array.isArray(rows)
          ? rows
              .map((row: any) => {
                const key = String(row?.module_key || '').trim();
                if (!key) {
                  return null;
                }
                const catalog = catalogMap.get(key);
                return {
                  key,
                  name: row?.name || catalog?.name,
                  labelKey: catalog?.labelKey,
                  can_view: Number(row?.can_view ?? 1),
                  can_create: Number(row?.can_create ?? 1),
                  can_manage: Number(row?.can_manage ?? 1)
                } as ModuleEntry;
              })
              .filter((item): item is ModuleEntry => !!item)
          : [];

        const merged = new Map(this.moduleCatalog.map((item) => [item.key, { ...item } as ModuleEntry]));
        normalized.forEach((item) => {
          const current = merged.get(item.key);
          if (current) {
            merged.set(item.key, {
              ...current,
              ...item,
              labelKey: current.labelKey || item.labelKey
            });
          } else {
            merged.set(item.key, item);
          }
        });

        this.availableModules = Array.from(merged.values());
        this.resetUserModules();
        if (this.editingUser?.id) {
          this.loadUserModules(this.editingUser.id);
        }
      },
      error: () => {
        this.availableModules = [...this.moduleCatalog];
      }
    });
  }

  private loadSelfCadastrosPermissions(sessionUser: any) {
    this.selfCadastrosPermissions = {};
    this.hasCadastrosRestrictions = false;
    const rows = Array.isArray(sessionUser['cadastros_permissions'])
      ? sessionUser['cadastros_permissions']
      : [];
    if (!rows.length) {
      return;
    }
    this.hasCadastrosRestrictions = true;
    rows.forEach((row: any) => {
      this.selfCadastrosPermissions[row.item_key] = {
        can_view: !!row.can_view,
        can_create: !!row.can_create,
        can_manage: !!row.can_manage
      };
    });
  }

  canCadastrosView(itemKey: string) {
    if (!this.hasCadastrosRestrictions) {
      return true;
    }
    return !!this.selfCadastrosPermissions[itemKey]?.can_view;
  }

  canCadastrosCreate(itemKey: string) {
    if (!this.hasCadastrosRestrictions) {
      return true;
    }
    const perms = this.selfCadastrosPermissions[itemKey];
    return !!(perms?.can_create || perms?.can_manage);
  }

  canCadastrosManage(itemKey: string) {
    if (!this.hasCadastrosRestrictions) {
      return true;
    }
    return !!this.selfCadastrosPermissions[itemKey]?.can_manage;
  }

  private resetUserModules() {
    this.userModulePermissions = {};
    this.availableModules.forEach((module) => {
      this.userModulePermissions[module.key] = {
        can_view: false,
        can_create: false,
        can_manage: false
      };
    });
  }

  private resetUserCadastrosPermissions() {
    this.userCadastrosPermissions = {};
    this.cadastrosItems.forEach((item) => {
      this.userCadastrosPermissions[item.key] = {
        can_view: false,
        can_create: false,
        can_manage: false
      };
    });
  }

  private buildUserModulesPayload() {
    return this.availableModules
      .map((module) => {
        const perms = this.userModulePermissions[module.key];
        if (!perms?.can_view) {
          return null;
        }
        return {
          key: module.key,
          can_view: true,
          can_create: perms.can_create,
          can_manage: perms.can_manage
        };
      })
      .filter(Boolean);
  }

  private buildCadastrosPayload() {
    return this.cadastrosItems
      .map((item) => {
        const perms = this.userCadastrosPermissions[item.key];
        if (!perms?.can_view) {
          return null;
        }
        return {
          key: item.key,
          can_view: true,
          can_create: perms.can_create,
          can_manage: perms.can_manage
        };
      })
      .filter(Boolean);
  }

  toggleUserModulePermission(moduleKey: string, field: 'can_view' | 'can_create' | 'can_manage', checked?: boolean) {
    const perms = this.userModulePermissions[moduleKey];
    if (!perms) {
      return;
    }
    perms[field] = checked ?? !perms[field];
    if (!perms.can_view) {
      perms.can_create = false;
      perms.can_manage = false;
      if (moduleKey === 'cadastros') {
        this.resetUserCadastrosPermissions();
      }
      if (moduleKey === 'controlop') {
        this.controlopDepartments = [];
        this.controlopLocations = [];
        this.controlopTabs = [];
      }
      if (moduleKey === 'controlhelp') {
        this.controlhelpDepartments = [];
      }
    }
    this.ensureUserPermissionsSubTab();
  }

  toggleCadastrosPermission(itemKey: string, field: 'can_view' | 'can_create' | 'can_manage', checked?: boolean) {
    const perms = this.userCadastrosPermissions[itemKey];
    if (!perms) {
      return;
    }
    perms[field] = checked ?? !perms[field];
    if (field === 'can_create' && perms.can_create) {
      perms.can_view = true;
    }
    if (field === 'can_manage' && perms.can_manage) {
      perms.can_view = true;
      perms.can_create = true;
    }
    if (field === 'can_create' && !perms.can_create) {
      perms.can_manage = false;
    }
    if (!perms.can_view) {
      perms.can_create = false;
      perms.can_manage = false;
    }
  }

  isCadastrosColumnAllSelected(field: 'can_view' | 'can_create' | 'can_manage') {
    if (!this.cadastrosItems.length) {
      return false;
    }
    return this.cadastrosItems.every((item) => {
      const perms = this.userCadastrosPermissions[item.key];
      return !!perms?.[field];
    });
  }

  toggleCadastrosColumn(field: 'can_view' | 'can_create' | 'can_manage', checked: boolean) {
    this.cadastrosItems.forEach((item) => {
      const perms = this.userCadastrosPermissions[item.key];
      if (!perms) {
        return;
      }
      if (field === 'can_view') {
        perms.can_view = checked;
        if (!checked) {
          perms.can_create = false;
          perms.can_manage = false;
        }
        return;
      }
      if (field === 'can_create') {
        perms.can_create = checked;
        if (checked) {
          perms.can_view = true;
        } else {
          perms.can_manage = false;
        }
        return;
      }
      perms.can_manage = checked;
      if (checked) {
        perms.can_view = true;
        perms.can_create = true;
      }
    });
  }

  showCadastrosPermissions() {
    return !!this.userModulePermissions['cadastros']?.can_view;
  }

  showControlopSelection() {
    return !!this.userModulePermissions['controlop']?.can_view;
  }

  showControlhelpSelection() {
    return !!this.userModulePermissions['controlhelp']?.can_view;
  }

  private ensureUserPermissionsSubTab() {
    if (this.userPermissionsSubTab === 'cadastros' && !this.showCadastrosPermissions()) {
      this.userPermissionsSubTab = 'modules';
    }
    if (this.userPermissionsSubTab === 'controlop' && !this.showControlopSelection()) {
      this.userPermissionsSubTab = 'modules';
    }
    if (this.userPermissionsSubTab === 'controlhelp' && !this.showControlhelpSelection()) {
      this.userPermissionsSubTab = 'modules';
    }
  }

  get controlopSelectAllLabel() {
    return this.isAllControlopDepartmentsSelected() ? 'Limpar selecao' : 'Selecionar todos';
  }

  private isAllControlopDepartmentsSelected() {
    if (!this.departments.length) {
      return false;
    }
    const uniqueDepartments = new Set(this.departments.map((dept) => Number(dept.id)));
    const selected = new Set(this.controlopDepartments.map((id) => Number(id)));
    return uniqueDepartments.size > 0 && uniqueDepartments.size === selected.size;
  }

  toggleControlopDepartmentsAll() {
    if (this.isAllControlopDepartmentsSelected()) {
      this.controlopDepartments = [];
      this.controlopLocations = [];
      return;
    }
    this.controlopDepartments = this.departments.map((dept) => Number(dept.id));
  }

  toggleControlopDepartment(departmentId: number, checked: boolean) {
    if (checked) {
      if (!this.controlopDepartments.includes(departmentId)) {
        this.controlopDepartments = [...this.controlopDepartments, departmentId];
      }
      return;
    }
    this.controlopDepartments = this.controlopDepartments.filter((id) => id !== departmentId);
    const allowedDepartments = new Set(this.controlopDepartments);
    this.controlopLocations = this.controlopLocations.filter((locId) => {
      const loc = this.locations.find((item) => Number(item.id) === Number(locId));
      return loc && allowedDepartments.has(Number(loc.department_id));
    });
  }

  toggleControlopLocation(locationId: number, checked: boolean) {
    if (checked) {
      if (!this.controlopLocations.includes(locationId)) {
        this.controlopLocations = [...this.controlopLocations, locationId];
      }
      return;
    }
    this.controlopLocations = this.controlopLocations.filter((id) => id !== locationId);
  }

  toggleControlopTab(tabKey: string, checked: boolean) {
    if (checked) {
      if (!this.controlopTabs.includes(tabKey)) {
        this.controlopTabs = [...this.controlopTabs, tabKey];
      }
      return;
    }
    this.controlopTabs = this.controlopTabs.filter((key) => key !== tabKey);
  }

  get controlhelpSelectAllLabel() {
    return this.isAllControlhelpDepartmentsSelected() ? 'Limpar selecao' : 'Selecionar todos';
  }

  toggleControlhelpDepartmentsAll() {
    if (this.isAllControlhelpDepartmentsSelected()) {
      this.controlhelpDepartments = [];
      return;
    }
    this.controlhelpDepartments = this.controlhelpDepartmentOptions.map((dept) => Number(dept.id));
  }

  toggleControlhelpDepartment(departmentId: number, checked: boolean) {
    if (checked) {
      if (!this.controlhelpDepartments.includes(departmentId)) {
        this.controlhelpDepartments = [...this.controlhelpDepartments, departmentId];
      }
      return;
    }
    this.controlhelpDepartments = this.controlhelpDepartments.filter((id) => id !== departmentId);
  }

  private isAllControlhelpDepartmentsSelected() {
    if (!this.controlhelpDepartmentOptions.length) {
      return false;
    }
    const available = new Set(this.controlhelpDepartmentOptions.map((dept) => Number(dept.id)));
    const selected = new Set(this.controlhelpDepartments.map((id) => Number(id)));
    return available.size > 0 && available.size === selected.size;
  }

  private loadUserModules(userId: number) {
    this.userService.getUserModules(userId).subscribe({
      next: (rows) => {
        if (!rows?.length) {
          return;
        }
        rows.forEach((row) => {
          if (!this.userModulePermissions[row.module_key]) {
            return;
          }
          this.userModulePermissions[row.module_key] = {
            can_view: !!row.can_view,
            can_create: !!row.can_create,
            can_manage: !!row.can_manage
          };
        });
      },
      error: () => {}
    });
  }

  private loadUserCadastrosPermissions(userId: number) {
    this.userService.getUserCadastrosPermissions(userId).subscribe({
      next: (rows) => {
        if (!rows?.length) {
          return;
        }
        rows.forEach((row) => {
          if (!this.userCadastrosPermissions[row.item_key]) {
            return;
          }
          this.userCadastrosPermissions[row.item_key] = {
            can_view: !!row.can_view,
            can_create: !!row.can_create,
            can_manage: !!row.can_manage
          };
        });
      },
      error: () => {}
    });
  }

  private loadUserControlopAssignments(userId: number) {
    this.userService.getUserControlopAssignments(userId).subscribe({
      next: (payload) => {
        this.controlopDepartments = (payload?.departments || []).map((dept: any) => Number(dept.id));
        this.controlopLocations = (payload?.locations || []).map((loc: any) => Number(loc.id));
        this.controlopTabs = (payload?.tabs || []).map((tab: any) => String(tab));
      },
      error: () => {
        this.controlopDepartments = [];
        this.controlopLocations = [];
        this.controlopTabs = [];
      }
    });
  }

  private loadUserControlhelpAssignments(userId: number) {
    this.userService.getUserControlhelpAssignments(userId).subscribe({
      next: (payload) => {
        this.controlhelpDepartments = (payload?.departments || []).map((dept: any) => Number(dept.id));
      },
      error: () => {
        this.controlhelpDepartments = [];
      }
    });
  }

  private fetchControlhelpDepartments() {
    const sessionUser = this.userSession.getUser();
    if (!sessionUser?.tenant_id) {
      return;
    }
    this.orgStructureService.getDepartments(sessionUser.tenant_id, null, true).subscribe({
      next: (rows) => {
        this.controlhelpDepartmentOptions = (rows || []).slice().sort((a: any, b: any) => {
          const labelA = a.sector_name ? `${a.sector_name} / ${a.name}` : a.name;
          const labelB = b.sector_name ? `${b.sector_name} / ${b.name}` : b.name;
          return String(labelA).localeCompare(String(labelB));
        });
      },
      error: () => {
        this.controlhelpDepartmentOptions = [];
      }
    });
  }
}
